import React from 'react';
import logo from '../img/community_desexing.png'
import {Link} from "react-router-dom";

export default function Header (props) {
	
	function signup() {
		window.location.href = '/signup';
	}
	
	function logMeIn() {
		window.location.href = 'https://www.talenthabitat.io';
	}
	
	return (
		<div>
			<div className={"hero"}>
				<div className={"hero-content"} style={{textAlign:'center', margin:50}}>
				<h2><img src={logo} style={{height:75}} /> </h2>
				<nav>
					{/*<li><a href="#">Home</a></li>*/}
					{/*<h2><img src={logo} style={{height:50}} /> </h2>*/}
					{/*<li><button className={"btn"} onClick={logMeIn} disabled>Log in</button></li>*/}
					{/*<li><Link to="/signup"><button className={"btn"} >Create account</button></Link></li>*/}
				</nav>
				</div>
			</div>
		</div>
	
	)
}